export const AGENTSDATA = [
    {
        "uuid": "5f8d3a7f-467b-97f3-062c-13acf203c006",
        "displayName": "Breach",
        "description": "The bionic Swede Breach fires powerful, targeted kinetic blasts to aggressively clear a path through enemy ground. The damage and disruption he inflicts ensures no fight is ever fair.",
        "developerName": "Breach",
        "displayIcon": "img/breach.png",
        "fullPortrait": "img/fullPortrait/Breach-fullportrait.png",
        "role": {
            "uuid": "1b47567f-8f7b-444b-aae3-b0c634622d10",
            "displayName": "Initiator",
            "description": "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Flashpoint",
                "description": "EQUIP a blinding charge. FIRE the charge to set a fast-acting burst through the wall. The charge detonates to blind all players looking at it.",
                "displayIcon": "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Fault Line",
                "description": "EQUIP a seismic blast. HOLD FIRE to increase the distance. RELEASE to set off the quake, dazing all players in its zone and in a line up to the zone.",
                "displayIcon": "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Aftershock",
                "description": "EQUIP a fusion charge. FIRE the charge to set a slow-acting burst through the wall. The burst does heavy damage to anyone caught in its area.",
                "displayIcon": "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Rolling Thunder",
                "description": "EQUIP a Seismic Charge. FIRE to send a cascading quake through all terrain in a large cone. The quake dazes and knocks up anyone caught in it.",
                "displayIcon": "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "f94c3b30-42be-e959-889c-5aa313dba261",
        "displayName": "Raze",
        "description": "Raze explodes out of Brazil with her big personality and big guns. With her blunt-force-trauma playstyle, she excels at flushing entrenched enemies and clearing tight spaces with a generous dose of \"boom\".",
        "developerName": "Clay",
        "characterTags": [
            "Area Damage Specialist"
        ],
        "displayIcon": "img/Raze.png",
        "fullPortrait": "img/fullPortrait/Raze-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Clay/Clay_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
            "displayName": "Duelist",
            "description": "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Blast Pack",
                "description": "INSTANTLY throw a Blast Pack that will stick to surfaces. RE-USE the ability after deployment to detonate, damaging and moving anything hit.",
                "displayIcon": "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Paint Shells",
                "description": "EQUIP a cluster grenade. FIRE to throw the grenade, which does damage and creates sub-munitions, each doing damage to anyone in their range.",
                "displayIcon": "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Boom Bot",
                "description": "EQUIP a Boom Bot. FIRE will deploy the bot, causing it to travel in a straight line on the ground, bouncing off walls. The Boom Bot will lock on to any enemies in its frontal cone and chase them, exploding for heavy damage if it reaches them.",
                "displayIcon": "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Showstopper",
                "description": "EQUIP a rocket launcher. FIRE shoots a rocket that does massive area damage on contact with anything.",
                "displayIcon": "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "601dbbe7-43ce-be57-2a40-4abd24953621",
        "displayName": "KAY/O",
        "description": "KAY/O is a machine of war built for a single purpose: neutralizing radiants. His power to suppress enemy abilities cripples his opponents' capacity to fight back, securing him and his allies the ultimate edge.",
        "developerName": "Grenadier",
        "characterTags": null,
        "displayIcon": "img/KAYO.png",
        "fullPortrait": "img/fullPortrait/Kayo-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Grenadier/Grenadier_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "1b47567f-8f7b-444b-aae3-b0c634622d10",
            "displayName": "Initiator",
            "description": "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Grenade",
                "displayName": "FRAG/ment",
                "description": "EQUIP an explosive fragment. FIRE to throw. The fragment sticks to the floor and explodes multiple times, dealing near lethal damage at the center with each explosion.",
                "displayIcon": "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ability1",
                "displayName": "FLASH/drive",
                "description": "EQUIP a flash grenade. FIRE to throw. The flash grenade explodes after a short fuse, blinding anyone in line of sight.",
                "displayIcon": "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "ZERO/point",
                "description": "EQUIP a suppression blade. FIRE to throw. The blade sticks to the first surface it hits, winds up, and suppresses anyone in the radius of the explosion.",
                "displayIcon": "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "NULL/cmd",
                "description": "INSTANTLY overload with polarized radianite energy that pulses from KAY/O in a massive radius. Enemies hit with pulses are suppressed for a short duration. While overloaded, KAY/O gains combat stim and can be re-stabilized if downed.",
                "displayIcon": "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "6f2a04ca-43e0-be17-7f36-b3908627744d",
        "displayName": "Skye",
        "description": "Hailing from Australia, Skye and her band of beasts trailblaze the way through hostile territory. With her creations hampering the enemy, and her power to heal others, the team is strongest and safest by Skye's side.",
        "developerName": "Guide",
        "characterTags": null,
        "displayIcon": "img/Skye.png",
        "fullPortrait": "img/fullPortrait/Skye-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Guide/Guide_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "1b47567f-8f7b-444b-aae3-b0c634622d10",
            "displayName": "Initiator",
            "description": "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Trailblazer",
                "description": "EQUIP a Tasmanian tiger trinket. FIRE to send out and take control of the predator.  While in control, FIRE to leap forward, exploding in a concussive blast and damaging directly hit enemies.",
                "displayIcon": "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Guiding Light",
                "description": "EQUIP a hawk trinket.  FIRE to send it forward.  HOLD FIRE to guide the hawk in the direction of your crosshair. RE-USE while the hawk is in flight to transform it into a flash.",
                "displayIcon": "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Regrowth",
                "description": "EQUIP a healing trinket.  HOLD FIRE to channel, healing allies in range and line of sight.  Can be reused until her healing pool is depleted.  Skye cannot heal herself.",
                "displayIcon": "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Seekers",
                "description": "EQUIP a Seeker trinket.  FIRE to send out three Seekers to track down the three closest enemies.  If a Seeker reaches its target, it nearsights them.",
                "displayIcon": "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "117ed9e3-49f3-6512-3ccf-0cada7e3823b",
        "displayName": "Cypher",
        "description": "The Moroccan information broker, Cypher is a one-man surveillance network who keeps tabs on the enemy's every move. No secret is safe. No maneuver goes unseen. Cypher is always watching.",
        "developerName": "Gumshoe",
        "characterTags": [
            "Detection",
            "Defensive Lockdown"
        ],
        "displayIcon": "img/Cypher.png",
        "fullPortrait": "img/fullPortrait/Cypher-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Gumshoe/Gumshoe_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "5fc02f99-4091-4486-a531-98459a3e95e9",
            "displayName": "Sentinel",
            "description": "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Cyber Cage",
                "description": "INSTANTLY toss the cyber cage in front of Cypher. ACTIVATE to create a zone that blocks vision and plays an audio cue when enemies pass through it",
                "displayIcon": "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Spycam",
                "description": "EQUIP a spycam. FIRE to place the spycam at the targeted location. RE-USE this ability to take control of the camera's view. While in control of the camera, FIRE to shoot a marking dart. This dart will reveal the location of any player struck by the dart.",
                "displayIcon": "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Trapwire",
                "description": "EQUIP a trapwire. FIRE to place a destructible and covert tripwire at the targeted location, creating a line that spans between the placed location and the wall opposite. Enemy players who cross a tripwire will be tethered, revealed, and dazed after a short period if they do not destroy the device in time. This ability can be picked up to be REDEPLOYED.",
                "displayIcon": "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Neural Theft",
                "description": "INSTANTLY use on a dead enemy player in your crosshairs to reveal the location of all living enemy players.",
                "displayIcon": "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "320b2a48-4d9b-a075-30f1-1f93a9b638fa",
        "displayName": "Sova",
        "description": "Born from the eternal winter of Russia's tundra, Sova tracks, finds, and eliminates enemies with ruthless efficiency and precision. His custom bow and incredible scouting abilities ensure that even if you run, you cannot hide. ",
        "developerName": "Hunter",
        "characterTags": [
            "Detection",
            "Area Damage"
        ],
        "displayIcon": "img/Sova.png",
        "fullPortrait": "img/fullPortrait/Sova-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Hunter/Hunter_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "1b47567f-8f7b-444b-aae3-b0c634622d10",
            "displayName": "Initiator",
            "description": "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Shock Bolt",
                "description": "EQUIP a bow with a shock bolt. FIRE to send the explosive bolt forward, detonating upon collision and damaging players nearby. HOLD FIRE to extend the range of the projectile. ALTERNATE FIRE to add up to two bounces to this arrow.",
                "displayIcon": "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Recon Bolt",
                "description": "EQUIP a bow with recon bolt. FIRE to send the recon bolt forward, activating upon collision and revealing the location of nearby enemies caught in the line of sight of the bolt. Enemies can destroy this bolt. HOLD FIRE to extend the range of the projectile. ALTERNATE FIRE to add up to two bounces to this arrow. ",
                "displayIcon": "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Owl Drone",
                "description": "EQUIP an owl drone. FIRE to deploy and take control of movement of the drone. While in control of the drone, FIRE to shoot a marking dart. This dart will reveal the location of any player struck by the dart.",
                "displayIcon": "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Hunter's Fury",
                "description": "EQUIP a bow with three long-range, wall-piercing energy blasts. FIRE to release an energy blast in a line in front of Sova, dealing damage and revealing the location of enemies caught in the line. This ability can be RE-USED up to two more times while the ability timer is active.",
                "displayIcon": "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/ultimate/displayicon.png"
            },
            {
                "slot": "Passive",
                "displayName": "Uncanny Marksman",
                "description": "Sova's custom bow can fire his arrows and bounce them off terrain. Holding fire charges the bow's power, and the bolt is loosed when released. Press alt fire to change the number of bounces.Your arrows can bounce off terrain. Holding left click increases the bow's range trajectory. Right clicking Toggle through the desired number of terrain bounces by right clicking. The arrow is loosed when left click is released.",
                "displayIcon": null
            }
        ]
    },
    {
        "uuid": "1e58de9c-4950-5125-93e9-a0aee9f98746",
        "displayName": "Killjoy",
        "description": "The genius of Germany, Killjoy secures and defends key battlefield positions with a collection of traps, turrets, and mines. Each invention is primed to punish any assailant too dumb to back down.",
        "developerName": "Killjoy",
        "characterTags": [
            "Defensive Lockdown",
            "Area Damage"
        ],
        "displayIcon": "img/Killjoy.png",
        "fullPortrait": "img/fullPortrait/Killjoy-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Killjoy/Killjoy_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "5fc02f99-4091-4486-a531-98459a3e95e9",
            "displayName": "Sentinel",
            "description": "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Grenade",
                "displayName": "Nanoswarm",
                "description": "EQUIP a Nanoswarm grenade. FIRE to throw the grenade. Upon landing, the Nanoswarm goes covert. ACTIVATE the Nanoswarm to deploy a damaging swarm of nanobots.  ",
                "displayIcon": "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ability1",
                "displayName": "ALARMBOT",
                "description": "EQUIP a covert Alarmbot. FIRE to deploy a bot that hunts down enemies that get in range.  After reaching its target, the bot explodes and applies Vulnerable to enemies in the area. HOLD EQUIP to recall a deployed bot.",
                "displayIcon": "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "TURRET",
                "description": "EQUIP a Turret. FIRE to deploy a turret that fires at enemies in a 180 degree cone. HOLD EQUIP to recall the deployed turret.",
                "displayIcon": "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Lockdown",
                "description": "EQUIP the Lockdown device. FIRE to deploy the device. After a long windup, the device Detains all enemies caught in the radius. The device can be destroyed by enemies.",
                "displayIcon": "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "707eab51-4836-f488-046a-cda6bf494859",
        "displayName": "Viper",
        "description": "The American Chemist, Viper deploys an array of poisonous chemical devices to control the battlefield and cripple the enemy's vision. If the toxins don't kill her prey, her mindgames surely will.",
        "developerName": "Pandemic",
        "characterTags": [
            "Vision Control Specialist"
        ],
        "displayIcon": "img/Viper.png",
        "fullPortrait": "img/fullPortrait/Viper-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Pandemic/Pandemic_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "4ee40330-ecdd-4f2f-98a8-eb1243428373",
            "displayName": "Controller",
            "description": "Controllers are experts in slicing up dangerous territory to set their team up for success.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Poison Cloud",
                "description": "EQUIP a gas emitter. FIRE to throw the emitter that perpetually remains throughout the round. RE-USE the ability to create a toxic gas cloud at the cost of fuel. This ability can be RE-USED more than once and can be picked up to be REDEPLOYED.",
                "displayIcon": "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Toxic Screen",
                "description": "EQUIP a gas emitter launcher that penetrates terrain. FIRE to deploy a long line of gas emitters. RE-USE the ability to create a tall wall of toxic gas at the cost of fuel. This ability can be RE-USED more than once.",
                "displayIcon": "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Snake Bite",
                "description": "EQUIP a chemical launcher. FIRE to launch a canister that shatters upon hitting the floor, creating a lingering chemical zone that damages and applies Vulnerable.",
                "displayIcon": "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Viper's Pit",
                "description": "EQUIP a chemical sprayer. FIRE to spray a chemical cloud in all directions around Viper, creating a large cloud that reduces the vision range of players and maximum health of enemies inside of it. HOLD the ability key to disperse the cloud early.",
                "displayIcon": "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/ultimate/displayicon.png"
            },
            {
                "slot": "Passive",
                "displayName": "Toxic",
                "description": "You gradually generate and replenish the toxin that fuels your abilities.  Enemies that cross through Viper's Poison Cloud, Toxic Screen, or Viper's Pit are instantly inflicted with at least 50 decay. Their decay level increases the longer they remain in contact with it.",
                "displayIcon": null
            }
        ]
    },
    {
        "uuid": "eb93336a-449b-9c1b-0a54-a891f7921d69",
        "displayName": "Phoenix",
        "description": "Hailing from the U.K., Phoenix's star power shines through in his fighting style, igniting the battlefield with flash and flare. Whether he's got backup or not, he's rushing in to fight on his own terms.",
        "developerName": "Phoenix",
        "characterTags": [
            "Flexibility",
            "Self-Sustain"
        ],
        "displayIcon": "img/Phoenix.png",
        "fullPortrait": "img/fullPortrait/Phoenix-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Phoenix/Phoenix_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
            "displayName": "Duelist",
            "description": "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Grenade",
                "displayName": "Blaze",
                "description": "EQUIP a flame wall. FIRE to create a line of flame that moves forward, creating a wall of fire that blocks vision and damages players passing through it. HOLD FIRE to bend the wall in the direction of your crosshair.",
                "displayIcon": "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ability1",
                "displayName": "Curveball",
                "description": "EQUIP a flare orb that takes a curving path and detonates shortly after throwing. FIRE to curve the flare orb to the left, detonating and blinding any player who sees the orb. ALTERNATE FIRE to curve the flare orb to the right.",
                "displayIcon": "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Hot Hands",
                "description": "EQUIP a fireball. FIRE to throw a fireball that explodes after a set amount of time or upon hitting the ground, creating a lingering fire zone that damages enemies.",
                "displayIcon": "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Run it Back",
                "description": "INSTANTLY place a marker at Phoenix's location. While this ability is active, dying or allowing the timer to expire will end this ability and bring Phoenix back to this location with full health. ",
                "displayIcon": "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/ultimate/displayicon.png"
            },
            {
                "slot": "Passive",
                "displayName": "Heating Up",
                "description": "PASSIVELY heal Phoenix instead of taking damage when standing in Phoenix's own fire",
                "displayIcon": null
            }
        ]
    },
    {
        "uuid": "41fb69c1-4189-7b37-f117-bcaf1e96f1bf",
        "displayName": "Astra",
        "description": "Ghanaian Agent Astra harnesses the energies of the cosmos to reshape battlefields to her whim. With full command of her astral form and a talent for deep strategic foresight, she's always eons ahead of her enemy's next move.",
        "developerName": "Rift",
        "characterTags": null,
        "displayIcon": "img/Astra.png",
        "fullPortrait": "img/fullPortrait/Astra-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Rift/Rift_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "4ee40330-ecdd-4f2f-98a8-eb1243428373",
            "displayName": "Controller",
            "description": "Controllers are experts in slicing up dangerous territory to set their team up for success.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Nova Pulse",
                "description": "Place Stars in Astral Form (Ultimate Key).\r\n\r\nACTIVATE a Star to detonate a Nova Pulse. The Nova Pulse charges briefly then strikes, concussing all players in its area.",
                "displayIcon": "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Nebula  / Dissipate",
                "description": "Place Stars in Astral Form (Ultimate Key). \r\n\r\nACTIVATE a Star to transform it into a Nebula (smoke).\r\n\r\nUSE a Star to Dissipate it, returning the star to be placed in a new location after a delay.\r\n\r\nDissipate briefly forms a fake Nebula at the Star's location before returning.",
                "displayIcon": "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Gravity Well",
                "description": "Place Stars in Astral Form (Ultimate Key).\r\n\r\nACTIVATE a Star to form a Gravity Well. Players in the area are pulled toward the center before it explodes, making all players still trapped inside vulnerable.",
                "displayIcon": "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Astral Form / Cosmic Divide",
                "description": "ACTIVATE to enter Astral Form where you can place Stars with PRIMARY FIRE. Stars can be reactivated later, transforming them into a Nova Pulse, Nebula, or Gravity Well.\r\n\r\nWhen Cosmic Divide is charged, use SECONDARY FIRE in Astral Form to begin aiming it, then PRIMARY FIRE to select two locations. An infinite Cosmic Divide connects the two points you select. Cosmic Divide blocks bullets and heavily dampens audio.",
                "displayIcon": "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/ultimate/displayicon.png"
            },
            {
                "slot": "Passive",
                "displayName": "Astral Form",
                "description": "ACTIVATE Ultimate to enter Astral Form and PRIMARY FIRE to place Stars. Target Stars with your Nova Pulse, Nebula, or Gravity Well to use those abilities.",
                "displayIcon": "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/passive/displayicon.png"
            }
        ]
    },
    {
        "uuid": "9f0d8ba9-4140-b941-57d3-a7ad57c6b417",
        "displayName": "Brimstone",
        "description": "Joining from the USA, Brimstone's orbital arsenal ensures his squad always has the advantage. His ability to deliver utility precisely and safely make him the unmatched boots-on-the-ground commander.  ",
        "developerName": "Sarge",
        "characterTags": [
            "Vision Control",
            "Area Damage"
        ],
        "displayIcon": "img/Brimstone.png",
        "fullPortrait": "img/fullPortrait/Brimstone-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Sarge/Sarge_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "4ee40330-ecdd-4f2f-98a8-eb1243428373",
            "displayName": "Controller",
            "description": "Controllers are experts in slicing up dangerous territory to set their team up for success.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Grenade",
                "displayName": "Stim Beacon",
                "description": "INSTANTLY toss a stim beacon in front of Brimstone. Upon landing, the stim beacon will create a field that grants players RapidFire.",
                "displayIcon": "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ability1",
                "displayName": "Incendiary",
                "description": "EQUIP an incendiary grenade launcher. FIRE to launch a grenade that detonates as it comes to a rest on the floor, creating a lingering fire zone that damages players within the zone.",
                "displayIcon": "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Sky Smoke",
                "description": "EQUIP a tactical map. FIRE to set locations where Brimstone's smoke clouds will land. ALTERNATE FIRE to confirm, launching long-lasting smoke clouds that block vision in the selected area.",
                "displayIcon": "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Orbital Strike",
                "description": "EQUIP a tactical map. FIRE to launch a lingering orbital strike laser at the selected location, dealing high damage-over-time to players caught in the selected area.",
                "displayIcon": "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "7f94d92c-4234-0a36-9646-3a87eb8b5c89",
        "displayName": "Yoru",
        "description": "Japanese native Yoru rips holes straight through reality to infiltrate enemy lines unseen. Using deception and aggression in equal measure, he gets the drop on each target before they know where to look.",
        "developerName": "Stealth",
        "characterTags": null,
        "displayIcon": "img/Yoru.png",
        "fullPortrait": "img/fullPortrait/Yoru-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Stealth/Stealth_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
            "displayName": "Duelist",
            "description": "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Grenade",
                "displayName": "FAKEOUT",
                "description": "EQUIP an echo that mimics footsteps when activated FIRE to activate and send the echo forward ALT FIRE to place an echo in place USE the inactive echo to send it forward.",
                "displayIcon": "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ability1",
                "displayName": "BLINDSIDE",
                "description": "EQUIP to rip an unstable dimensional fragment from reality. FIRE to throw the fragment, activating a flash that winds up once it collides with a hard surface in world.",
                "displayIcon": "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "GATECRASH",
                "description": "EQUIP to harness a rift tether FIRE to send the tether out moving forward ALT FIRE to place a tether in place ACTIVATE to teleport to the tether's location.",
                "displayIcon": "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "DIMENSIONAL DRIFT",
                "description": "EQUIP a mask that can see between dimensions FIRE to drift into Yoru's dimension, unable to be affected or seen by enemies from the outside.",
                "displayIcon": "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "569fdd95-4d10-43ab-ca70-79becc718b46",
        "displayName": "Sage",
        "description": "The bastion of China, Sage creates safety for herself and her team wherever she goes. Able to revive fallen friends and stave off forceful assaults, she provides a calm center to a hellish battlefield.",
        "developerName": "Thorne",
        "characterTags": [
            "Recovery",
            "Stalling"
        ],
        "displayIcon": "img/Sage.png",
        "fullPortrait": "img/fullPortrait/Sage-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Thorne/Thorne_PrimaryAsset",
        "isFullPortraitRightFacing": true,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "5fc02f99-4091-4486-a531-98459a3e95e9",
            "displayName": "Sentinel",
            "description": "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Slow Orb",
                "description": "EQUIP a slowing orb. FIRE to throw a slowing orb forward that detonates upon landing, creating a lingering field that slows players caught inside of it.",
                "displayIcon": "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Healing Orb",
                "description": "EQUIP a healing orb. FIRE with your crosshairs over a damaged ally to activate a heal-over-time on them. ALT FIRE while Sage is damaged to activate a self heal-over-time.",
                "displayIcon": "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Barrier Orb",
                "description": "EQUIP a barrier orb. FIRE places a wall that fortifies after a few seconds. ALT FIRE rotates the targeter.",
                "displayIcon": "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Resurrection",
                "description": "EQUIP a resurrection ability. FIRE with your crosshairs placed over a dead ally to begin resurrecting them. After a brief channel, the ally will be brought back to life with full health.",
                "displayIcon": "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "a3bfb853-43b2-7238-a4f1-ad90e9e46bcc",
        "displayName": "Reyna",
        "description": "Forged in the heart of Mexico, Reyna dominates single combat, popping off with each kill she scores. Her capability is only limited by her raw skill, making her sharply dependant on performance. ",
        "developerName": "Vampire",
        "characterTags": [
            "Evasion",
            "Self-Sustain"
        ],
        "displayIcon": "img/Reyna.png",
        "fullPortrait": "img/fullPortrait/Reyna-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Vampire/Vampire_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
            "displayName": "Duelist",
            "description": "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Devour",
                "description": "Soul Harvest: Enemies that die to Reyna, or die within 3 seconds of taking damage from Reyna, leave behind Soul Orbs that last 3 seconds.\r\nDevour: INSTANTLY consume a nearby soul orb, rapidly healing for a short duration. Health gained through this skill exceeding 100 will decay over time. If EMPRESS is active, this skill will automatically cast and not consume the Soul Orb.",
                "displayIcon": "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Dismiss",
                "description": "INSTANTLY consume a nearby Soul Orb, becoming intangible for a short duration. If EMPRESS is active, also become invisible.",
                "displayIcon": "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Leer",
                "description": "EQUIP an ethereal, destructible eye. ACTIVATE to cast the eye a short distance forward. The eye will Nearsight all enemies who look at it.",
                "displayIcon": "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Empress",
                "description": "INSTANTLY enter a frenzy, increasing firing, equip and reload speed dramatically. Gain infinite charges of Soul Harvest abilities. When an enemy dies to Reyna, or dies within 3 seconds of taking damage from Reyna, the duration is renewed.",
                "displayIcon": "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "8e253930-4c05-31dd-1b6c-968525494517",
        "displayName": "Omen",
        "description": "A phantom of a memory, Omen hunts in the shadows. He renders enemies blind, teleports across the field, then lets paranoia take hold as his foe scrambles to uncover where he might strike next.",
        "developerName": "Wraith",
        "characterTags": [
            "Mobility",
            "Vision Control"
        ],
        "displayIcon": "img/Omen.png",
        "fullPortrait": "img/fullPortrait/Omen-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Wraith/Wraith_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "4ee40330-ecdd-4f2f-98a8-eb1243428373",
            "displayName": "Controller",
            "description": "Controllers are experts in slicing up dangerous territory to set their team up for success.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Paranoia",
                "description": "EQUIP a blinding orb.  FIRE to throw it forward, briefly reducing the vision range and deafening all players it touches. This projectile can pass straight through walls.",
                "displayIcon": "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Dark Cover",
                "description": "EQUIP a shadow orb, entering a phased world to place and target the orbs. PRESS the ability key to throw the shadow orb to the marked location, creating a long-lasting shadow sphere that blocks vision. HOLD FIRE while targeting to move the marker further away. HOLD SECONDARY FIRE while targeting to move the marker closer. PRESS RELOAD to toggle normal targeting view.",
                "displayIcon": "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Shrouded Step",
                "description": "EQUIP a shrouded step ability and see its range indicator. FIRE to begin a brief channel, then teleport to the marked location.",
                "displayIcon": "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "From the Shadows",
                "description": "EQUIP a tactical map. FIRE to begin teleporting to the selected location. While teleporting, Omen will appear as a Shade that can be destroyed by an enemy to cancel his teleport, or PRESS EQUIP for Omen to cancel his teleport.",
                "displayIcon": "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/ultimate/displayicon.png"
            }
        ]
    },
    {
        "uuid": "add6443a-41bd-e414-f6ad-e58d267f4e95",
        "displayName": "Jett",
        "description": "Representing her home country of South Korea, Jett's agile and evasive fighting style lets her take risks no one else can. She runs circles around every skirmish, cutting enemies up before they even know what hit them.",
        "developerName": "Wushu",
        "characterTags": [
            "Evasion",
            "Mobility"
        ],
        "displayIcon": "img/Jett.png",
        "fullPortrait": "img/fullPortrait/Jett-fullportrait.png",
        "assetPath": "ShooterGame/Content/Characters/Wushu/Wushu_PrimaryAsset",
        "isFullPortraitRightFacing": false,
        "isPlayableCharacter": true,
        "isAvailableForTest": true,
        "role": {
            "uuid": "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
            "displayName": "Duelist",
            "description": "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
            "displayIcon": "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
            "assetPath": "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset"
        },
        "abilities": [
            {
                "slot": "Ability1",
                "displayName": "Updraft",
                "description": "INSTANTLY propel Jett high into the air.",
                "displayIcon": "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/ability1/displayicon.png"
            },
            {
                "slot": "Ability2",
                "displayName": "Tailwind",
                "description": "INSTANTLY propel Jett in the direction she is moving. If Jett is standing still, she will propel forward.",
                "displayIcon": "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/ability2/displayicon.png"
            },
            {
                "slot": "Grenade",
                "displayName": "Cloudburst",
                "description": "INSTANTLY throw a projectile that expands into a brief vision-blocking cloud on impact with a surface. HOLD the ability key to curve the smoke in the direction of your crosshair.",
                "displayIcon": "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/grenade/displayicon.png"
            },
            {
                "slot": "Ultimate",
                "displayName": "Blade Storm",
                "description": "EQUIP a set of highly accurate throwing knives that recharge on killing an opponent. FIRE to throw a single knife at your target. ALTERNATE FIRE to throw all remaining daggers at your target.",
                "displayIcon": "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/ultimate/displayicon.png"
            },
            {
                "slot": "Passive",
                "displayName": "Drift",
                "description": "Holding the jump button while falling allows you to glide through the air.",
                "displayIcon": "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/passive/displayicon.png"
            }
        ]
    }
]